import { LowerCasePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit, output } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { BiTranslateDirective, BiTranslatePipe, BiTranslateService } from "@globals/bi-translate";
import { isStringNullOrEmpty } from "@globals/helper-functions";
import { BiSkipLinkComponent } from "@iframeModulesShared/components/bi-skip-link/bi-skip-link.component";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { SubscriptionModuleSharedService } from "../subscription-module-shared.service";

export type SupplyNumberAndAlias = {
  supplyNumber: string;
  alias?: string;
};

@Component({
  selector: "create-supply-number-subscription",
  templateUrl: "./create-supply-number-subscription.component.html",
  styles: [":host {vertical-align: top;}"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "relative px-2",
    "[cdkTrapFocus]": "true"
  },
  imports: [BiTranslateDirective, BiTranslatePipe, ReactiveFormsModule, ButtonModule, InputTextModule, LowerCasePipe, BiSkipLinkComponent]
})
export class CreateSupplyNumberSubscriptionComponent implements OnInit {
  onCreateSubscription = output<SupplyNumberAndAlias>();
  onBack = output();

  public supplyNumberForm: FormGroup;

  public supplyNumberLabel = this.translator.instant("shared.SupplyNumber");
  public aliasLabel = this.translator.instant("shared.Alias");

  constructor(
    public sharedService: SubscriptionModuleSharedService,
    private translator: BiTranslateService
  ) {}

  public ngOnInit() {
    this.supplyNumberForm = new FormGroup({
      supplyNumber: new FormControl("", Validators.required),
      alias: new FormControl("", Validators.maxLength(200))
    });

    if (!isStringNullOrEmpty(this.sharedService.getCachedModuleConfigObject().supplyNumberText)) this.supplyNumberLabel = this.sharedService.getCachedModuleConfigObject().supplyNumberText;

    if (!isStringNullOrEmpty(this.sharedService.getCachedModuleConfigObject().aliasText)) this.aliasLabel = this.sharedService.getCachedModuleConfigObject().aliasText;
  }

  public get supplyNumberCtrl() {
    return this.supplyNumberForm.get("supplyNumber");
  }

  public get aliasCtrl() {
    return this.supplyNumberForm.get("alias");
  }
}
